//
//
//
//

// QUASAR COMPONENT- QAlert removed, use QBanner

import { QBanner } from "quasar";

export default {
    name: "AQToast",
    mixins: [QBanner],
    props: {
        message: { type: String, required: true, default: "" }, // use this as title in complex toast (title + main text)
        caption: { type: String, required: false, default: "" }, // use this as main text in complex toast (title + main text)
        type: { type: String, required: false, default: "info" }, // available types - info/warning/error/success
        timeout: { type: Number, required: false, default: 5000 },
        hasClose: { type: Boolean, required: false, default: true },
        buttonLabel: { type: String, required: false, default: "" }
    },
    mounted() {
        this.$toast.showNotify({
            message: this.message,
            caption: this.caption,
            type: this.type,
            timeout: this.timeout,
            buttonLabel: this.buttonLabel,
            hasClose: this.hasClose,
            actionEvent: this.actionEvent,
            closeEvent: this.closeEvent
        });

        if (this.timeout) {
            setTimeout(() => {
                this.$destroy();
            }, this.timeout + 1200);
        }
    },
    destroyed() {
        this.$emit("close");
    },
    methods: {
        closeEvent() {
            this.$destroy();
        },
        actionEvent() {
            this.$emit("action");
        }
    }
};

